var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.multipage === true ? 'multi-page':'single-page'},[_c('page-content',{attrs:{"breadcrumb":_vm.breadcrumb,"title":_vm.title,"logo":_vm.logo}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }